
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * 
 * 
 * 
 * 
 *                             ====  DO NOT EDIT THIS FILE  ====  
 * 
 * 
 * 
 *        This file is automatically generated.  Any direct changes to this file will be lost.
 * 
 * 
 * 
 * 
 * 
 * 
 * 
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */


_registerSassExport("site-themes", {
  "MemberDirect - Standard": "theme-memberdirect-standard"
});

_registerSassExport("third-party-themes", {
  "root": {
    "grid": "ag-theme-quartz-dark",
    "html-editor": null
  },
  "MemberDirect - Dark": {
    "grid": "ag-theme-quartz-dark",
    "html-editor": "trumbowyg-dark"
  },
  "MemberDirect - Standard": {
    "grid": "ag-theme-quartz",
    "html-editor": null
  }
});

_registerSassExport("chart-themes", {
  "root": "rsDefault",
  "MemberDirect - Dark": "rsDark",
  "MemberDirect - Standard": "rsDefault"
});

_registerSassExport("hiddenCssClass", "display-none");

_registerSassExport("iospwasplashbackgroundcolor", "rgb(244, 246, 247)");

_registerSassExport("fallbackpagebackgroundcolor", "rgb(255, 255, 255)");

